import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

class SentimentPie extends Component{
  constructor(props){
    super(props);
  }

  componentDidMount() {
    const data = this.props.data;
    let chart = null;

    if(this.props.type == 'quick'){
      this.createQuickPie(chart, data);
    }
    else {
      this.createPie(chart, data);
    }
  }

  componentWillUnmount() {
    if(this.chart) this.chart.dispose();
  }

  createQuickPie = (chart, dataSet) => {
    chart = am4core.create(this.pieChart, am4charts.PieChart);
    chart.data = dataSet.sentiment;
    chart.padding(0,0,0,0);

    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "sentiment";
    series.slices.template.propertyFields.fill = "color";
    series.slices.template.tooltipText = `${dataSet.keyword}({sentiment}) [bold]{value.percent.formatNumber('#.#')}%[/] ({value.value})`;
    // series.labels.template.disabled = true;
    // series.ticks.template.disabled = true;
    // series.slices.template.tooltipText = "";
    // series.slices.template.stroke = am4core.color("#fff");

    let hs = series.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    let as = series.slices.template.states.getKey("active");
    as.properties.shiftRadius = 0;

    chart.legend = new am4charts.Legend();

    this.chart = chart;
  }

  createPie = (chart, dataSet) => {
    chart = am4core.create(this.pieChart, am4charts.PieChart);
    chart.data = dataSet;
    chart.padding(0,0,0,0);

    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "value";
    series.dataFields.category = "sentiment";
    series.dataFields.color= "color";
    // series.labels.template.disabled = true;
    // series.ticks.template.disabled = true;
    // series.slices.template.tooltipText = "";
    // series.slices.template.stroke = am4core.color("#fff");

    let hs = series.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    let as = series.slices.template.states.getKey("active");
    as.properties.shiftRadius = 0;

    chart.legend = new am4charts.Legend();

    this.chart = chart;
  }

  render() {
    return(
      <>
        <div id="sentiment-pie" ref={ref=>(this.pieChart=ref)} style={{ width: this.props.width, height: this.props.height}}></div>
      </>
    )
  }
}

export default SentimentPie;
